import React, { useState, useEffect } from "react";
import { FaEdit, FaEye, FaMinus, FaPlus } from "react-icons/fa";
// import { FundEditModal } from "../modals/FundEditModal";
import axios from "axios";
import { formatRupees, roundNumber } from "../../../../utils/inputsValidation";
import { ActionFormModal } from "../../PortfolioReview/modals/ActionFormModal";
import api from "../../../../utils/api";
import moment from "moment";


export default function HierarchicalTable({ userData, isPortfolioData, onlyone, isChecked, setIsChecked }) {
  const [showEditModal, setShowEditModal] = useState(false);
  const [openSipFormAllData, setOpenSipFormAllData] = useState({});
  const [viewPrErrors, setViewPrErrors] = useState([]);

  const roomId = new URLSearchParams(window.location.search).get("clientId");
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedGoalDetail, setSelectedGoalDetail] = useState({});
  const [selectedClientreviewedfolio, setSelectedClientreviewedfolio] =
    useState({});
  const [editRowData, setEditRowData] = useState({});
  const [subRowExpanded, setSubRowExpanded] = useState({});
  const [showActionFormModal, setShowActionFormModal] = useState(false);
  const [openItems, setOpenItems] = useState({});
  const [subRowExpandedMobile, setSubRowExpandedMobile] = useState({});


  const toNumber = (value) => {
    if (!value) return 0;
    return formatRupees(value.toString().replace(/,/g, ""));
  };

  const goalGoalData = isPortfolioData.folioGoalData
    ? Object.entries(isPortfolioData.folioGoalData)
      .filter(([key, value]) => value.goalName)
      .map(([key, value]) => ({
        key,
        goalName: value.goalName,
        goalId: value.goalId,
        aum: value.aum,
        client_id: value.client_id,
        runningSIP: value.runningSIP,
      }))
    : [];
  // console.log("isPortfolioData",isPortfolioData);
  console.log("userData", userData);

  const handleEditClick = async (rowData, rowData2) => {
    console.log("rowData", rowData, rowData2);

    try {
      // Set the row data for editing
      setEditRowData(rowData2);

      // Extract relevant data from the rowData
      // const detail = rowData['Detail']?.[0];
      // if (!detail) {
      //   console.error("Detail is missing in the provided rowData.");
      //   return;
      // }

      // const { folio, ISIN, Scheme, Total } = detail;
      const currentValue = rowData2.Total?.[0]?.["Current Value"];

      // Fetch goal details and client reviewed folio details
      const goalDetail = await getGoalDetail(rowData2.folio, rowData2.ISIN);
      const clientReviewedFolio = await getClientreviewedfolio(
        rowData2.folio,
        rowData2.ISIN
      );
      const issip = clientReviewedFolio?.portfolio_type_sip || 0;
      // console.log("goalDetail",clientReviewedFolio,goalDetail,issip,currentValue);
      // Initialize variables with default values
      let goalName = "Unmapped";
      let goalId = "";
      let runningSIP = 0;
      let requiredSIP = 0;
      let expectedReturn = 0;
      let targetYear = 0;
      let startYear = 0;
      let targetAmount = 0;
      let aum = 0;

      if (goalDetail) {
        goalName = goalDetail.goalName || goalName;
        goalId = goalDetail.goalId || goalId;
        runningSIP = goalDetail.runningSIP || runningSIP;
        targetAmount = goalDetail.targetAmount || targetAmount;
        aum = goalDetail?.aum || 0;
      }

      // console.log({
      //   goalName,
      //   goalId,
      //   runningSIP,
      //   requiredSIP,
      //   expectedReturn,
      //   targetYear,
      //   startYear,
      //   targetAmount,
      //   aum,
      //   issip,

      // });

      // // Open SIP form with the gathered data
      opensipform(
        rowData2.Scheme,
        rowData2.ISIN,
        rowData2.folio,
        issip,
        currentValue,
        goalName,
        goalId,
        runningSIP,
        aum,
        requiredSIP,
        expectedReturn,
        targetYear,
        startYear,
        targetAmount
      );

      // Show the edit modal
      setShowEditModal(true);
    } catch (error) {
      console.error("Error handling edit click:", error);
    }
  };

  async function opensipform(
    schemename,
    ISIN,
    portfolioid,
    isSIP,
    currentval,
    goalName,
    goalId,
    runningSIP,
    aum,
    requiredSIP,
    cagr,
    goalYear,
    startYear,
    targetAmount
  ) {
    const allData = {
      clientid: roomId,
      currentval: currentval,
      schemename: schemename,
      portfolioid: portfolioid,
      ISIN: ISIN,
      isSIP: isSIP,
      moneyformatecurval: currentval,
      goalName: goalName,
      goalId: goalId,
      goalsOption: isPortfolioData.options.options,
      runningSIP: runningSIP,
      aum: aum,
      requiredSIP: requiredSIP,
      cagr: cagr,
      goalYear: goalYear,
      startYear: startYear,
      targetAmount: targetAmount,
    };
    // console.log("allData",allData);
    setOpenSipFormAllData(allData);
  }

  const toggleRow = (key) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [key]: !prevExpandedRows[key],
    }));
  };
  const fetchViewPrErrors = async (prRowId) => {
    try {
      // Swal.fire({
      //   text: "Please wait...",
      //   imageUrl: 'https://www.finedge.in/assets/images/download.gif',
      //   showConfirmButton: false,
      //   allowOutsideClick: false,
      //   allowEscapeKey: false,
      // });

      const allData = {
        clientid: roomId,
        pr_row_id: prRowId,
      };
      // API Call
      const response = await api.post(`advisor/view_pr_errors`, allData);
      //   console.log("view_pr_errors res",response.data);
      setViewPrErrors(response.data.data);
    } catch (error) {
      console.error("Error fetching portfolio data:", error);
      // Swal.fire({
      //   icon: 'error',
      //   title: 'Oops...',
      //   text: 'Failed to load portfolio data. Please try again later.',
      // });
    } finally {
      // Swal.close(); // Ensure the alert closes in both success and error cases
      setShowActionFormModal(true);
    }
  };

  const toggleSubRow = (key) => {
    setSubRowExpanded((prevSubRowExpanded) => ({
      ...prevSubRowExpanded,
      [key]: !prevSubRowExpanded[key],
    }));
  };
  // const getGoalDetail = (folio, ISIN) => {
  //   const goalGoalData = isPortfolioData?.data?.folioGoalData
  //     ? Object.entries(isPortfolioData.folioGoalData)
  //       .filter(([key, value]) => value.goalName)
  //       .map(([key, value]) => ({
  //         key,
  //         goalName: value.goalName,
  //       }))
  //     : [];

  //   const key = `${folio}${ISIN}`;
  //   const matchedEntry = goalGoalData.find((entry) => entry.key === key);
  //   console.log('goalGoalData',isPortfolioData?.data?.folioGoalData,goalGoalData);
    
  //   return matchedEntry || {};
  // };
  

  const getGoalDetail = (folio, ISIN) => {
  try {
    const folioGoalData = isPortfolioData?.data?.folioGoalData ?? {};

    const goalGoalData = Object.entries(folioGoalData)
      .filter(([_, value]) => value?.goalName)
      .map(([key, value]) => ({
        key,
        goalName: value.goalName?.trim() || "Unnamed Goal",
      }));

    const searchKey = `${folio}${ISIN}`;
    const matchedEntry = goalGoalData.find(
      (entry) => entry.key === searchKey
    );

    // console.log("Goal Match Debug =>", {
    //   folioGoalData,
    //   searchKey,
    //   matchedEntry,
    // });

    return matchedEntry || {};

  } catch (error) {
    console.error("Error in getGoalDetail:", error);
    return {};
  }
};

  
  const getClientreviewedfolio = (folio, ISIN) => {
    const clientreviewedfolio = isPortfolioData?.data?.clientreviewedfolio;
    if (!clientreviewedfolio || !Array.isArray(clientreviewedfolio)) {
      return null;
    }
    return clientreviewedfolio.find(
      (clientFolio) =>
        clientFolio.portfolio_id === folio &&
        clientFolio.portfolio_ISIN === ISIN
    );
  };
  useEffect(() => {
    // Automatically expand all rows on load

    const initialExpandedRows = {};
    userData?.forEach((item, index) => {
      const mainKey = `0-${index}`;
      initialExpandedRows[mainKey] = true;

      if (item.Detail) {
        item.Detail.forEach((subItem, subIndex) => {
          const subKey = `0-${index}-sub-${subIndex}`;
          initialExpandedRows[subKey] = false; // Initially, sub-items are collapsed
        });
      }
    });

    setExpandedRows(initialExpandedRows);
  }, [userData]);

  const handleToggle = () => {
    setIsChecked((prev) => !prev); // Toggle state
  };

  const toggleItem = (index) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleToggleDetails = (key) => {
    setSubRowExpandedMobile((prev) => ({  
      ...prev,
      [key]: !prev[key],
    }));
  };

  console.log("isChecked", isChecked);

  function calculateEffectiveBalance(transactions, fundnametype, fundSubName) {
    let effiBal = 0;
    let fromDate = new Date();

    // 🧠 Apply fund type rules to determine cutoff date
    if (
      (fundnametype === "Equity" && fundSubName !== "Equity - ELSS") ||
      (fundnametype === "Hybrid" && fundSubName !== "Hybrid - Arbitrage")
    ) {
      fromDate.setMonth(fromDate.getMonth() - 12); // 12 months ago
    } else if (
      fundnametype === "Debt" ||
      fundnametype === "Hybrid - Arbitrage" ||
      fundnametype === "Others"
    ) {
      // No change, keep current fromDate
    } else {
      fromDate.setMonth(fromDate.getMonth() - 36); // 36 months ago
    }

    const validTypes = ["SIP Purchase", "Purchase", "STP In", "Switch In"];

    (transactions || []).forEach((tx) => {
      const dateStr = tx["Transaction Date"];
      const parts = dateStr?.includes("-")
        ? dateStr.split("-")
        : dateStr?.split("/") || [];

      if (parts.length === 3) {
        let [dd, mm, yy] = parts;

        // Normalize year
        if (yy.length === 2) yy = `20${yy}`;
        if (mm.length === 1) mm = `0${mm}`;
        if (dd.length === 1) dd = `0${dd}`;

        const txDate = new Date(`${yy}-${mm}-${dd}`);
        const isValidType = validTypes.includes(tx["Transaction Type"]);

        if (!isNaN(txDate) && isValidType && txDate < fromDate) {
          effiBal += parseFloat(tx["Current Value"]);
        }
      }
    });
console.log('');

    return effiBal;
  }


  const renderTableRows = (data, level = 0) => {
    const portfoioData = data?.[0]?.Portfoio ? Object.values(data[0].Portfoio) : [];
    if (!Array.isArray(portfoioData) || portfoioData.length === 0) return null;

    return portfoioData.map((item, index) => {
      const mainKey = `${level}-${index}`;

      return (
        <React.Fragment key={mainKey}>
          {/* ===== Main Fund Row (same theme as first) ===== */}
          {item?.["Fund Name"] && (
            <tr onClick={() => toggleRow?.(mainKey)} className="border-bottom">
              <td className="fs-14" style={{ backgroundColor: "#d0ebd0" }}>
                <p className="m-1 fw-bold">{item["Fund Name"]}</p>
              </td>

              <td className="fs-14 fw-normal align-middle text-end" style={{ backgroundColor: "#d0ebd0" }}>
                {formatRupees(item?.["Fund Total"]?.["Investment Amount"])}
              </td>

              <td className="fs-14 fw-normal align-middle text-end" style={{ backgroundColor: "#d0ebd0" }}>
                {/* same center header feel for this column */}
                {formatRupees(item?.["Fund Total"]?.["Current Value"])}
              </td>

              <td className="fs-14 fw-normal align-middle text-end" style={{ backgroundColor: "#d0ebd0" }}>
                {formatRupees(item?.["Fund Total"]?.["Gainloss"])}
              </td>

              <td className="fs-14 fw-normal align-middle text-end" style={{ backgroundColor: "#d0ebd0" }}>
                {item?.["Fund Total"]?.["Cagr"] ?? "N/A"}
              </td>

              <td className="fs-14 fw-normal align-middle text-end" style={{ backgroundColor: "#d0ebd0" }}>
                {item?.["Fund Total"]?.["Abs Return"] != null
                  ? `${item["Fund Total"]["Abs Return"]}%`
                  : "N/A"}
              </td>

              <td className="fs-14 fw-normal align-middle" style={{ backgroundColor: "#d0ebd0" }}></td>
              <td className="fs-14 fw-normal align-middle" style={{ backgroundColor: "#d0ebd0" }}></td>
            </tr>
          )}

          {/* ===== Sub-funds (same alignment & look) ===== */}
          {Array.isArray(item?.Detail) &&
            item.Detail.length > 0 &&
            item.Detail.map((detail, detailIndex) => {
              const subFund = detail;
              const subFundDetails = subFund?.Detail || [];

              return subFundDetails.map((subFundDetail, subFundDetailIndex) => {
                const subKey = `${mainKey}-sub-${subFundDetailIndex}`;
                const subFundTotal = subFundDetail?.Total?.[0] || {};
                const subFundTransaction = subFundDetail?.Transaction || [];
                const subRowFolio = subFundDetail?.folio || "";
                const subRowISIN = subFundDetail?.ISIN || "";
                const goalName =
                  getGoalDetail(subRowFolio, subRowISIN)?.goalName || "Unmapped";

                const fundnametype = item["Fund Name"];
                const fundSubName = subFund["Fund Sub Name"];

                const effiBal = calculateEffectiveBalance(
                  subFundDetail?.Transaction,
                  fundnametype,
                  fundSubName
                );

                console.log("effiBal", effiBal, subFundTotal, subFundDetail?.Transaction, fundnametype, fundSubName);

                // const getFromDate = () => {
                //   const today = new Date();
                //   const clone = new Date(today);
                //   const subName = fundSubName?.["Fund Sub Name"];

                //   if (
                //     (fundnametype === "Equity" && subName !== "Equity - ELSS") ||
                //     (fundnametype === "Hybrid" && subName !== "Hybrid - Arbitrage")
                //   ) {
                //     clone.setFullYear(clone.getFullYear() - 1);
                //   } else if (
                //     fundnametype === "Debt" ||
                //     subName === "Hybrid - Arbitrage" ||
                //     fundnametype === "Others"
                //   ) {
                //     // keep today
                //   } else {
                //     clone.setFullYear(clone.getFullYear() - 3);
                //   }
                //   const dd = String(clone.getDate()).padStart(2, "0");
                //   const mm = String(clone.getMonth() + 1).padStart(2, "0");
                //   const yy = clone.getFullYear();
                //   return `${dd}/${mm}/${yy}`;
                // };


                const getFromDate = () => {
                  const InvestedSince = subFundTransaction?.[0]?.["Transaction Date"] || "";

                  // 🗓️ Parse safely (allow both "-" and "/" separators)
                  const fromDate = moment(InvestedSince, ["DD-MM-YY", "DD-MM-YYYY", "DD/MM/YY", "DD/MM/YYYY"], true);

                  // console.log(
                  //   "InvestedSince Parsed:",
                  //   InvestedSince,
                  //   fromDate.isValid() ? fromDate.format("YYYY-MM-DD") : "Invalid"
                  // );

                  // ✅ Return valid formatted date or blank if invalid
                  return fromDate.isValid() ? fromDate.format("YYYY-MM-DD") : "";
                };

                const actionHTML =
                  getClientreviewedfolio(subRowFolio, subRowISIN)?.recommended_action || "";
                const clientreviewedfolioData = getClientreviewedfolio(
                  subRowFolio,
                  subRowISIN
                );
                return (
                  <React.Fragment key={subKey}>
                    <tr className="border-bottom">
                      {/* Fund / Start Date (same typography) */}
                      <td className="fs-14 py-3 fw-normal align-middle" style={{ width: "18%" }}>
                        <span className="fs-12 d-inline-flex align-items-center gap-2">
                          {subFundDetail?.Scheme || "No Sub Name"}
                        </span>
                        <p className="fs-12 mb-0 fw-bold">Start Date: {getFromDate()}</p>
                        <p>
                        {clientreviewedfolioData?.portfolio_type_sip === 1 && "(SIP)"}
                      </p>
                      </td>

                      {/* Right aligned numeric columns (same as first) */}
                      <td className="fs-14 py-3 fw-normal align-middle text-end">
                        {formatRupees(subFundTotal?.Amount)}
                      </td>

                      <td className="fs-14 py-3 fw-normal align-middle text-end">
                        {isChecked ? formatRupees(effiBal) : formatRupees(subFundTotal?.["Current Value"])}
                      </td>

                      <td className="fs-14 py-3 fw-normal align-middle text-end">
                        {formatRupees(subFundTotal?.["Gainloss"])}
                      </td>

                      <td className="fs-14 py-3 fw-normal align-middle text-end">
                        {subFundTotal?.["Cagr"] ?? "N/A"}
                      </td>

                      <td className="fs-14 py-3 fw-normal align-middle text-end">
                        {subFundTotal?.["Abs Return"] ?? "N/A"}
                      </td>

                      <td className="fs-14 fw-normal align-middle">
                        {goalName}
                      </td>

                      <td className="fs-14 py-3 fw-normal align-middle" style={{ width: "25%" }}>
                        {/* {actionHTML?.trim() ? (
                          <div
                            onClick={() => setShowActionFormModal?.(true)}
                            dangerouslySetInnerHTML={{ __html: actionHTML }}
                          />
                        ) : (
                          "No Action required"
                        )} */}
                        {actionHTML ? (
                      <div
                        onClick={() => {fetchViewPrErrors(clientreviewedfolioData.pr_row_id)}}
                        dangerouslySetInnerHTML={{ __html: actionHTML }}
                      />
                    ) : (
                      "No Action required"
                    )}
                      </td>
                    </tr>

                    {/* (Optional) Transactions block – keep your existing one if needed */}
                  </React.Fragment>
                );
              });
            })}

          {/* ===== Fund Total row (same look) ===== */}
          {/* <tr className="fund-summary-row" style={{ backgroundColor: "#5b7f395c" }}>
            <td className="fs-14 fw-bold">Total</td>

            <td className="fs-14 fw-bold text-end">
              {formatRupees(
                formatRupees(String(item?.["Fund Total"]?.["Investment Amount"] || "0").replace(/,/g, ""))
              )}
            </td>

            <td className="fs-14 fw-bold text-end">
              {formatRupees(
                formatRupees(String(item?.["Fund Total"]?.["Current Value"] || "0").replace(/,/g, ""))
              )}
            </td>

            <td className="fs-14 fw-bold text-end">
              {formatRupees(
                formatRupees(String(item?.["Fund Total"]?.["Gainloss"] || "0").replace(/,/g, ""))
              )}
            </td>

            <td className="fs-14 fw-bold text-end">
              {item?.["Fund Total"]?.["Cagr"] || "-"}
            </td>

            <td className="fs-14 fw-bold text-end">
              {item?.["Fund Total"]?.["Abs Return"] || "-"}%
            </td>

            <td colSpan={2}></td>
          </tr> */}

          {/* <tr aria-hidden="true"><td colSpan={8} style={{ height: 8 }} /></tr> */}
        </React.Fragment>
      );
    });
  };

  const renderInfoRow = (data, level = 0) => {
    const portfoioData = data?.[0]?.Portfoio
      ? Object.values(data[0]?.Portfoio)
      : null;

    if (!portfoioData) return null;

    return portfoioData.map((item, index) => {
      const mainKey = `${level}-${index}`;
      return (
        <React.Fragment key={mainKey}>
          {item.Detail?.length > 0 &&
            item.Detail.map((subFund, detailIndex) => {
              const subFundDetails = subFund?.Detail || [];
              return subFundDetails.map((subFundDetail, subFundDetailIndex) => {
                const subKey = `${mainKey}-sub-${subFundDetailIndex}`;
                const subFundTotal = subFundDetail?.Total?.[0] || {};
                const subRowFolio = subFundDetail?.folio || "";
                const subRowISIN = subFundDetail?.ISIN || "";
                const goalName =
                  getGoalDetail(subRowFolio, subRowISIN)?.goalName ||
                  "Unmapped";
                const reviewedAction =
                  getClientreviewedfolio(subRowFolio, subRowISIN)
                    ?.recommended_action || "";

                return (
                  <div key={subKey} className="mb-3 border-bottom pb-2">
                    <div className="d-flex justify-content-between">
                      <span className="fw-semibold">
                        {subFundDetail.Scheme || "No Sub Name"}
                      </span>
                      <button
                        className="btn btn-sm btn-outline-success px-2 py-0"
                        onClick={() => handleToggleDetails(subKey)}
                      >
                        {subRowExpandedMobile[subKey] ? "▲" : "▼"}
                      </button>

                    </div>

                    {subRowExpandedMobile[subKey] && (
                      <>
                        <div className="d-flex justify-content-between mt-2">
                          <span>Inv Cost</span>
                          <span>{formatRupees(subFundTotal?.Amount)}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Current Value</span>
                          <span>
                            {formatRupees(subFundTotal?.["Current Value"])}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Gain/Loss</span>
                          <span>{formatRupees(subFundTotal?.Gainloss)}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>CAGR</span>
                          <span>{subFundTotal?.Cagr || "N/A"}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Abs Rtn</span>
                          <span>{subFundTotal?.["Abs Return"] || "N/A"}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Goal</span>
                          <span>{goalName}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span>Action</span>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: reviewedAction,
                            }}
                          />
                        </div>
                      </>
                    )}
                  </div>
                );
              });
            })}
        </React.Fragment>
      );
    });
  };


  return (
    <>
      {/* Responsive wrapper (Bootstrap way) */}
      <div className="table-responsive">
        <table className="table align-middle mb-0 d-none d-md-table table-portfolio table-striped table-hover">
          <caption>{userData?.[0]?.Name || ''}</caption>

          {/* EXACT same widths as first table */}
          <colgroup>
            <col style={{ width: '20%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '14%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '10%' }} />
            <col style={{ width: '16%' }} />
          </colgroup>

          <thead className="sticky-header">
            <tr>
              <th scope="col" className="back-clrgreen txt-color-revers">Fund Name</th>

              <th scope="col" className="back-clrgreen txt-color-revers text-end">Inv Cost</th>

              <th scope="col" className="back-clrgreen txt-color-revers">
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <span>{isChecked ? 'Load Free Unit' : 'Current Value'}</span>
                  {onlyone === 'yes' && (
                    <div className="form-check form-switch m-0 toggle-color">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="valueToggle2"
                        checked={isChecked}
                        onChange={handleToggle}
                        aria-label="Toggle between Current Value and Load Free Unit"
                      />
                    </div>
                  )}
                </div>
              </th>

              <th scope="col" className="back-clrgreen txt-color-revers text-end">Gain/Loss</th>
              <th scope="col" className="back-clrgreen txt-color-revers text-end">CAGR</th>
              <th scope="col" className="back-clrgreen txt-color-revers text-end">Abs Rtn</th>
              <th scope="col" className="back-clrgreen txt-color-revers">Mapped To</th>
              <th scope="col" className="back-clrgreen txt-color-revers">Action</th>
            </tr>
          </thead>

          <tbody>{renderTableRows(userData)}</tbody>

          {userData?.[0] && (
            <tfoot>
              <tr>
                <th scope="row" className="total-cell">Total</th>

                <th className="total-cell text-end">
                  {formatRupees(userData[0]?.['Grand Total']?.Amount)}
                </th>

                <th className="total-cell text-end">
                {formatRupees(userData[0]["Grand Total"]?.Gainloss)}
                </th>

                <th className="total-cell text-end">
                  {formatRupees(userData[0]?.['Grand Total']?.Gainloss)}
                </th>

                <th className="total-cell text-end">{userData[0]?.['Grand Total']?.Cagr || '-'}</th>
                <th className="total-cell text-end">{userData[0]?.['Grand Total']?.['Abs Return'] || '-'}</th>

                <th className="total-cell" />
                <th className="total-cell" />
              </tr>
            </tfoot>
          )}

         
        </table>
      </div>


      {/* <FundEditModal
                                      show={showEditModal}
                                      onHide={() => setShowEditModal(false)}
                                      roomId={roomId}
                                      isPortfolioData={isPortfolioData}
                                      editRowData={editRowData}
                                      selectedGoalDetail={selectedGoalDetail}
                                      selectedClientreviewedfolio={selectedClientreviewedfolio}
                                      openSipFormAllData={openSipFormAllData}
                                      // defaultValues={defaultData}
                                      /> */}
      <div className="d-block d-md-none">
        {userData?.[0] && (
          <div className="border border-1 rounded-3 p-3 mb-3 bg-white shadow-sm">
            <div
              className="d-flex justify-content-between align-items-center mb-3"
              onClick={() => toggleItem(userData[0]?.Name)}
              style={{ cursor: "pointer" }}
            >
              <h5 className="fs-16 fw-bold m-0">{userData[0]?.Name}</h5>
              <span>
                {openItems[userData[0]?.Name] ? (
                  <FaMinus className="text-danger" />
                ) : (
                  <FaPlus className="text-success" />
                )}
              </span>
            </div>

            {openItems[userData[0]?.Name] && (
              <>
                {renderInfoRow(userData)}

                {/* Total Section */}
                <div className="mt-4 bg-light p-3 rounded-3 border border-success">
                  <h6 className="text-success fw-bold mb-3">Total</h6>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Investment Cost</span>
                    <span>{formatRupees(userData[0]["Grand Total"]?.Amount)}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Current Value</span>
                    <span className="text-success">
                      {formatRupees(
                        userData[0]["Grand Total"]?.["Current Value"]
                      )}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Gain/Loss</span>
                    <span>
                      {formatRupees(userData[0]["Grand Total"]?.Gainloss)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>CAGR</span>
                    <span>{userData[0]["Grand Total"]?.Cagr}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <span>Abs Return</span>
                    <span>{userData[0]["Grand Total"]?.["Abs Return"]}</span>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      
      <ActionFormModal
        show={showActionFormModal}
        content={"No Form created"}
        onHide={() => {
          setShowActionFormModal(false);
          setViewPrErrors([]);
        }}
        roomId={roomId}
        prRowId={isPortfolioData?.clientreviewedfolio?.[0]?.pr_row_id}
        viewPrErrors={viewPrErrors}
        setViewPrErrors={setViewPrErrors}
      />
    </>
  );
}
